import { render } from "./events-index.vue?vue&type=template&id=75781f7c"
import script from "./events-index.vue?vue&type=script&lang=js"
export * from "./events-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__